/** Budget asta di riferimento (FVM Fantacalcio è su base 1000). */
export const FVM_AUCTION_BUDGET = 500;

/**
 * FVM listone → crediti stimati per asta da 500 (FVM / 2).
 * @returns {string}
 */
export function formatFvmValue(fvm) {
  if (fvm === null || fvm === undefined) return '-';
  const n = Number(fvm);
  if (!Number.isFinite(n) || n <= 0) return '-';
  return String(Math.round(n / 2));
}
